{
  "jan": "Ion",
  "feb": "Chwe",
  "mar": "Maw",
  "apr": "Ebr",
  "may": "Mai",
  "jun": "Meh",
  "jul": "Gor",
  "aug": "Aws",
  "sep": "Med",
  "oct": "Hyd",
  "nov": "Tach",
  "dec": "Rhag",
  "legendTitle": "Allwedd",
  "numberOfReports": "Nifer o adroddiadau",
  "total": "Cyfanswm"
}